
import {getViewReferrals} from '../api/getViewReferrals';
import {setGetViewReferralAction} from '../action';

const setGetViewReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewReferrals(params);
            if (data.status === 'success') {
                dispatch(setGetViewReferralAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewReferrals
}